import { CheckIndexedDBIsSupport } from "@/IndexedDB/tabIndexedDB";
import { CheckBroadcastIsSupport } from "@/broadcastChannel/tabChannel";
import { BroadcastReCreateTab, SetUserChannel } from "@/broadcastChannel/userChannel";
import {
  ActivityLogSource,
  ApplipcationStoreType,
  LoadingStatusType,
  Locales,
  TypeComponentNoti,
  UserType,
} from "@/enums/enums";
import { SocketConnect } from "@/helper/notificationHelper";
import { GetMessageExceptionCode } from "@/helper/shareHelper";
import { ClearMasterTabFromCookies, InsertTabIdToTabDB, UpdateTabMerchantId } from "@/helper/tabHelper";
import {
  MerchantId,
  RefreshToken,
  RemoveCookiesToken,
  SetCookiesAccessToken,
  SetCookiesKeepLogin,
  SetCookiesRefreshToken,
} from "@/helper/userHelper";
import { i18n } from "@/i18n";
import { MerchantInFoModel } from "@/model/merchant/MerchantInFoModel";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { UserModel } from "@/model/user/userModel";
import router from "@/router/index";
import API from "@/service/Index";
import { DatadogRumService } from "@/service/datadog/datadogRumService";
import { ConvertToUserModel } from "@/service/user/authenFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import {
  CompareMerchantNameEn,
  CompareMerchantNameTh,
  ConvertToMerchantList,
  GetSelectedMerchant,
} from "../../helper/merchantHelper";
import TextHelper from "../../helper/textHelper";

@Module({ namespaced: true })
class LogIn extends VuexModule {
  public loginLoadingStatus = LoadingStatusType.None;
  public userModel: UserModel | null = null;
  public merchantList = [] as Array<MerchantInFoModel>;
  public merchantListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public selectMerchant: SelectedMerchantModel | null = null;
  public setSelectMerchantLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public refreshTokenExpirationLodingStatus: LoadingStatusType = LoadingStatusType.None;
  public merchantModelByIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public merchantModelListForMap: Map<number, { merchant: SelectedMerchantModel }> = new Map();
  public favoriteMerchantList: any = [];
  public favoriteMerchantListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateFavoriteMerchantLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public deleteFavoriteMerchantLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getLoginLoadingStatus(): LoadingStatusType {
    return this.loginLoadingStatus;
  }

  get getMerchantList(): Array<MerchantInFoModel> {
    const merchantListMockup = [...this.merchantList];
    if (i18n.locale == Locales.TH) {
      return merchantListMockup.sort(CompareMerchantNameTh);
    } else {
      return merchantListMockup.sort(CompareMerchantNameEn);
    }
  }
  get getMerchantListLoadingStatus(): LoadingStatusType {
    return this.merchantListLoadingStatus;
  }
  get getUserModel(): UserModel | null {
    return this.userModel;
  }
  get getMerchant(): SelectedMerchantModel | null {
    return this.selectMerchant;
  }
  get getSetSelectMerchantLoadingStatus(): any {
    return this.setSelectMerchantLoadingStatus;
  }
  get getMerchantModelListForMap() {
    return this.merchantModelListForMap;
  }

  get getMerchantModelByIdLoadingStatus() {
    return this.merchantModelByIdLoadingStatus;
  }

  get getFavoriteMerchantList() {
    return this.favoriteMerchantList;
  }

  get getFavoriteMerchantListLoadingStatus() {
    return this.favoriteMerchantListLoadingStatus;
  }

  get getUpdateFavoriteMerchantLoadingStatus() {
    return this.updateFavoriteMerchantLoadingStatus;
  }

  get getDeleteFavoriteMerchantLoadingStatus() {
    return this.deleteFavoriteMerchantLoadingStatus;
  }

  @Mutation
  public MutationLoginLoadingStatus(status: LoadingStatusType): void {
    this.loginLoadingStatus = status;
  }

  @Mutation
  public MutationsSelectMerchant(_object: SelectedMerchantModel): void {
    this.selectMerchant = _object;
  }

  @Mutation
  public MutationsSetSelectMerchantLoadingStatus(status: LoadingStatusType): void {
    this.setSelectMerchantLoadingStatus = status;
  }

  @Mutation
  public MutationSetUserModel(userModel: UserModel) {
    this.userModel = userModel;
    sessionStorage.setItem("eui", userModel.userId.PeakEncryption());
  }

  @Mutation
  public MutationSetMerchantsList(merchantsList: Array<MerchantInFoModel>) {
    this.merchantList = merchantsList;
  }

  @Mutation
  public MutationSetMerchantListLoadingStatus(status: LoadingStatusType) {
    this.merchantListLoadingStatus = status;
  }

  @Mutation
  public MutationsSetRefreshTokenExpirationLodingStatus(status: LoadingStatusType) {
    this.refreshTokenExpirationLodingStatus = status;
  }

  @Mutation
  MutationSetFavoriteMerchantList(favoriteMerchantList: any) {
    this.favoriteMerchantList = favoriteMerchantList;
  }

  @Mutation
  MutationSetFavoriteMerchantListLoadingStatus(status: LoadingStatusType) {
    this.favoriteMerchantListLoadingStatus = status;
  }

  @Mutation
  MutationSetUpdateFavoriteMerchantLoadingStatus(status: LoadingStatusType) {
    this.updateFavoriteMerchantLoadingStatus = status;
  }

  @Mutation
  MutationSetDeleteFavoriteMerchantLoadingStatus(status: LoadingStatusType) {
    this.deleteFavoriteMerchantLoadingStatus = status;
  }

  @Mutation
  public MutationSetMerchantModelByIdLoadingStatus(status: LoadingStatusType) {
    this.merchantModelByIdLoadingStatus = status;
  }

  @Mutation
  MutationSetMerchantModelList(input: { merchantId: number; merchant: SelectedMerchantModel }) {
    this.merchantModelListForMap.set(input.merchantId, { merchant: input.merchant });
  }

  @Action
  public cleanLogin() {
    return API.AuthenService.DoGetNewAccessTokenByRefreshToken().then((res) => {
      if (res.status.IsSuccess()) {
        const idToken = res.data.id_token;
        const userId: any = this.userModel?.userId.PeakEncryption();
        return API.AuthenService.DoRevokeToken(idToken, userId).then((resRevokeToken) => {
          this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.None);
          RemoveCookiesToken();
          sessionStorage.removeItem("emi");
          return resRevokeToken;
        });
      } else {
        this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.None);
        RemoveCookiesToken();
        sessionStorage.removeItem("emi");
        return res;
      }
    });
  }

  @Action
  public DoLogIn(_input: any): void {
    this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Loading);
    let encpw: string = _input.password;

    if (_input.userType == UserType.Email) {
      encpw = TextHelper.CreateToken(_input.password);
    }

    const requestInput = {
      userName: _input.username,
      password: encpw,
      userType: _input.userType,
      iss: _input.iss || "",
    };
    const source = ActivityLogSource.PeakAsset;
    API.AuthenService.DoGetAccessToken(requestInput, source).then((resAccessToken) => {
      if (resAccessToken.status.IsSuccess()) {
        const responseCode = resAccessToken.data.response_code ? resAccessToken.data.response_code : 200;

        if (responseCode.IsSuccess()) {
          const token = {
            accessToken: resAccessToken.data.access_token,
            refreshToken: resAccessToken.data.refresh_token,
          };

          if (_input.keepLogin) {
            SetCookiesKeepLogin();
            SetCookiesAccessToken(token.accessToken);
            SetCookiesRefreshToken(token.refreshToken, true);
          } else {
            SetCookiesAccessToken(token.accessToken);
            SetCookiesRefreshToken(token.refreshToken);
          }

          API.AuthenService.DoGetUserInfo().then(async (resUserInfo) => {
            if (resUserInfo.status.IsSuccess()) {
              DatadogRumService.SetUserFromUserInfo(resUserInfo?.data?.userInfo);
              const userModel = ConvertToUserModel(resUserInfo.data.userInfo);
              this.context.commit("MutationSetUserModel", userModel);
              this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Success);
              ClearMasterTabFromCookies();
              if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
                await InsertTabIdToTabDB();
                SetUserChannel(userModel.userId);
                BroadcastReCreateTab();
              }
              const lastUrl = localStorage.getItem("lastUrlPeakAsset");
              if (lastUrl) {
                ClearMasterTabFromCookies();
                localStorage.removeItem("lastUrlPeakAsset");
                window.location.href = lastUrl;
              } else {
                router.push({ name: "selectList" });
              }
            } else {
              this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Success);
              router.push("/logout");
            }
          });
        } else {
          this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Fail);
          RemoveCookiesToken();
        }
      } else {
        this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Fail);
        RemoveCookiesToken();
      }
    });
  }

  @Action
  public AuthorizeModels(routerName: string) {
    const refreshToken = RefreshToken();
    if (refreshToken) {
      const userInfo: any = this.userModel;
      if (userInfo == null) {
        this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Loading);
        try {
          API.AuthenService.DoGetUserInfo().then(async (resUserInfo) => {
            if (resUserInfo.status.IsSuccess()) {
              DatadogRumService.SetUserFromUserInfo(resUserInfo?.data?.userInfo);
              const userModel = ConvertToUserModel(resUserInfo.data.userInfo);
              this.context.commit("MutationSetUserModel", userModel);
              this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Success);
              if (routerName == "login") {
                router.push({ name: "selectList" });
              }
              if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
                await InsertTabIdToTabDB();
                SetUserChannel(userModel.userId);
              }
              SocketConnect();
            } else {
              this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.None);
              router.push("/SessionExpire");
            }
          });
        } catch (err) {
          this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.None);
          router.push("/SessionExpire");
        }
      }
    } else {
      router.push("/logout");
    }
  }

  @Action
  DoRedirectByApplipcationStore(applipcationStoreType: ApplipcationStoreType) {
    API.AuthenService.DoGetUserInfo().then((resAccess) => {
      const userInfo: any = this.userModel;
      if (resAccess.data.responseCode.IsSuccess()) {
        switch (applipcationStoreType) {
          case ApplipcationStoreType.Peak:
            window.open(`${process.env.VUE_APP_PeakEngine}home?emi=${MerchantId().PeakEncryption()}`);
            break;
          case ApplipcationStoreType.NewPeak:
            window.open(`${process.env.VUE_APP_PeakAccount}home?emi=${MerchantId().PeakEncryption()}`);

            break;
          case ApplipcationStoreType.Payroll:
            window.open(`${process.env.VUE_APP_PeakPayroll}home?emi=${MerchantId().PeakEncryption()}`);

            break;
          case ApplipcationStoreType.Board:
            window.open(`${process.env.VUE_APP_PeakBoard}home?emi=${MerchantId().PeakEncryption()}`);

            break;
          case ApplipcationStoreType.Tax:
            window.open(`${process.env.VUE_APP_PeakTax}home?emi=${MerchantId().PeakEncryption()}`);

            break;
        }
      } else {
        router.push("/SessionExpire");
      }
    });
  }

  @Action
  public DoGetMerchantList() {
    if (this.merchantListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSetMerchantListLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetMerchantListByUserId().then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          const merchantList = ConvertToMerchantList(res.data.merchantList);
          this.context.commit("MutationSetMerchantsList", merchantList);
        }
        this.context.commit("MutationSetMerchantListLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoSelectMerchant(merchantId: number) {
    if (this.setSelectMerchantLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationsSetSelectMerchantLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetSelectedMerchant(merchantId).then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          const selectMerchant = GetSelectedMerchant(res.data.merchant);
          if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
            UpdateTabMerchantId(selectMerchant?.merchantId);
          }
          this.context.commit("MutationsSelectMerchant", selectMerchant);
        } else {
          this.context.commit("MutationsSelectMerchant", null);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("MutationsSetSelectMerchantLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetRefreshTokenExpiration() {
    if (this.refreshTokenExpirationLodingStatus !== LoadingStatusType.Loading) {
      const refreshToken = RefreshToken();
      if (refreshToken) {
        this.context.dispatch("Loading/IsLoading", true, { root: true });
        this.context.commit("MutationsSetRefreshTokenExpirationLodingStatus", LoadingStatusType.Loading);
        API.AuthenService.DoGetRefreshTokenExpiration().then((res) => {
          if (res.status.IsSuccess()) {
            const lastUrl = localStorage.getItem("lastUrlPeakAsset");
            if (lastUrl) {
              localStorage.removeItem("lastUrlPeakAsset");
              window.location.href = lastUrl;
            } else {
              router.push({ name: "selectList" });
            }
          } else {
            RemoveCookiesToken();
          }
          this.context.dispatch("Loading/IsLoading", false, { root: true });
          this.context.commit("MutationsSetRefreshTokenExpirationLodingStatus", LoadingStatusType.Success);
        });
      } else {
        RemoveCookiesToken();
      }
    }
  }

  @Action
  public DoGetFavoriteMerchant() {
    if (this.favoriteMerchantListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetFavoriteMerchantListLoadingStatus", LoadingStatusType.Loading);

      API.MerchantService.DoGetFavoriteMerchant().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationSetFavoriteMerchantList", res.data.merchantFavorite);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);

          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("MutationSetFavoriteMerchantListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoUpdateFavoriteMerchant(merchantId: number) {
    if (this.updateFavoriteMerchantLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetUpdateFavoriteMerchantLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoUpdateFavoriteMerchant(merchantId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationSetFavoriteMerchantListLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("MutationSetUpdateFavoriteMerchantLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoDeleteFavoriteMerchant(merchantId: number) {
    if (this.deleteFavoriteMerchantLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetDeleteFavoriteMerchantLoadingStatus", LoadingStatusType.Loading);

      API.MerchantService.DoDeleteFavoriteMerchant(merchantId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationSetFavoriteMerchantListLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("MutationSetDeleteFavoriteMerchantLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetMerchantModelById(merchantId: number) {
    return new Promise((resolve) => {
      this.context.commit("MutationSetMerchantModelByIdLoadingStatus", LoadingStatusType.Loading);

      const merchantModelOnLocal = this.merchantModelListForMap.get(merchantId) ?? null;

      if (merchantModelOnLocal) {
        setTimeout(() => {
          this.context.commit("MutationSetMerchantModelByIdLoadingStatus", LoadingStatusType.Success);
          resolve({ ...merchantModelOnLocal.merchant });
        }, 0);
      } else {
        API.MerchantService.DoGetSelectedMerchant(merchantId).then((res: any) => {
          if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
            const merchant = GetSelectedMerchant(res.data.merchant);
            this.context.commit("MutationSetMerchantModelList", { merchantId: merchantId, merchant: merchant });
            resolve({ ...merchant });
          } else {
            this.context.commit("MutationSetMerchantModelList", { merchantId: merchantId, merchant: null });
            resolve(null);
          }
          this.context.commit("MutationSetMerchantModelByIdLoadingStatus", LoadingStatusType.Success);
        });
      }
    });
  }

  @Action
  public DoIntrospectAccessToken() {
    return new Promise((resolve) => {
      API.AuthenService.DoIntrospectAccessToken().then((res) => {
        if (res.status.IsSuccess()) {
          resolve(res.data.active);
        } else {
          resolve(false);
        }
      });
    });
  }
}

export default LogIn;
